import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { usePatientSubscriptions } from "src/context/PatientSubscriptionsProvider";
import { useRecommendedDosage } from "src/context/RecommendedDosageProvider";
import ProductCard from "src/pages/PatientDashboard/components/OneTimeProducts/components/ProductCard";
import SubscriptionProductCard from "../../pages/PatientDashboard/components/OneTimeProducts/components/SubscriptionProductCard/SubscriptionProductCard";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { ProductCategories } from "src/api/types";

const RecommendedDose = () => {
  const recommended = useRecommendedDosage();
  const { t } = useTranslation();
  const component = "patient-dashboard.recommended-dose";
  const activeSub = usePatientSubscriptions((s) =>
    s.find(
      (sub) =>
        sub.product_category.name === ProductCategories.WeightLoss &&
        sub.status !== "canceled",
    ),
  );
  const { pathname } = useLocation();

  const isSubView = useMemo(
    () => activeSub != null && pathname.includes("care"),
    [activeSub, pathname],
  );

  if (recommended == null) return null;
  if (activeSub != null && !pathname.includes("care")) return null;

  return (
    <Stack gap={1}>
      <Typography fontWeight={700}>
        {t(
          `${component}.text`,
          "Your next recommended dosage based on your current order:",
        )}
      </Typography>
      {isSubView ? (
        <SubscriptionProductCard product={recommended} />
      ) : (
        <ProductCard product={recommended} />
      )}
    </Stack>
  );
};

export default RecommendedDose;
